import { render, staticRenderFns } from "./aboutlangsi.vue?vue&type=template&id=07807eb6&"
import script from "./aboutlangsi.vue?vue&type=script&lang=js&"
export * from "./aboutlangsi.vue?vue&type=script&lang=js&"
import style0 from "./aboutlangsi.vue?vue&type=style&index=0&id=07807eb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports